import { Component, Input, OnInit } from '@angular/core';
import { debounce } from 'lodash';
import { ProjectService } from '../../../services/project.service';
import { MenuService } from '../../../../widgets/mega-menu/mega-menu.service.component';
import { UiService } from '../../../services/core.ui.service';

@Component({
    selector: 'project-list',
    template: require('./project-list.component.html'),
})
export class ProjectListComponent implements OnInit {
    @Input() project: any;

    projects: any[] | false = false;
    filterText: string = '';
    miniMenuProject: any = false;
    miniLoading: any = false;
    refresh: any = false;

    paging = {
        page_size: 20,
        page_num: 1
    };

    constructor(
        private projectService: ProjectService,
        private menuService: MenuService,
        private uiService: UiService,
    ) {
        // Debounce refresh to avoid excessive calls
        this.refresh = debounce(this.fetchProjects.bind(this), 400);
    }

    ngOnInit() {
        this.fetchProjects();
    }

    setFilterText(txt: string) {
        this.filterText = txt;
        this.refresh();
    }

    showProjectMiniMenu(unixName: string) {
        // Toggle display if currently shown
        if ((this.miniMenuProject && this.miniMenuProject.unixName) === unixName) {
            this.miniMenuProject = false;
            return false;
        }

        this.miniLoading = unixName;

        this.menuService.getProjectMenu(unixName).then(
            (pm: any) => {
                this.miniMenuProject = pm;
            },
            (result: any) => {
                console.error('Error fetching project menu:', unixName, result);
                this.uiService.message.showError(
                    `Sorry, could not load project menu for ${unixName}. The project is not active, or you are not allowed to see it.`,
                    'Project Menu'
                );
            }
        ).finally(() => { this.miniLoading = false; });
    }

    onPaging(params: any) {
        this.paging = {
            page_num: params && params.pageNum ? params.pageNum : this.paging.page_num,
            page_size: params && params.pageSize ? params.pageSize : this.paging.page_size
        };
        this.fetchProjects();
    }

    private fetchProjects() {
        this.miniLoading = false;
        this.miniMenuProject = false;
        this.projects = false;

        const params = Object.assign({
            inOrg: this.project && this.project.unixName,
            text: this.filterText,
            sort_field: 'projectName'
        }, this.paging);

        this.projectService.search(params)
            .then(
                (response: any) => {
                    this.projects = response && response.items ? response.items : [];
                },
                (response: any) => {
                    console.log(response);
                    this.projects = [];
                }
            );
    }

    trackByProjectId(index: number, project: any): any {
        return project?.id ?? project;
    }
}
